import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const FeaturedVoices = ({ onFollow }) => {
  const featuredHosts = [
  {
    id: 1,
    name: 'Анна Медитация',
    avatar: "https://images.unsplash.com/photo-1699594550911-9a2eab4a614d",
    avatarAlt: 'Профессиональное фото женщины с длинными темными волосами в белой одежде на фоне природы',
    bio: 'Практик медитации и осознанности. Помогаю найти внутренний покой через голос.',
    followers: 12500,
    broadcasts: 156,
    isFollowing: false,
    badge: 'verified'
  },
  {
    id: 2,
    name: 'Дмитрий Философ',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_13f4b3d4d-1763295780084.png",
    avatarAlt: 'Портрет мужчины средних лет с бородой в очках на нейтральном фоне',
    bio: 'Исследую глубины человеческого сознания через философские беседы.',
    followers: 8900,
    broadcasts: 89,
    isFollowing: false,
    badge: 'featured'
  },
  {
    id: 3,
    name: 'Мария Путешественница',
    avatar: "https://images.unsplash.com/photo-1651932043410-c4e41f68044d",
    avatarAlt: 'Фото молодой женщины с рюкзаком на фоне гор и неба',
    bio: 'Делюсь историями из путешествий по островам и континентам.',
    followers: 15200,
    broadcasts: 203,
    isFollowing: true,
    badge: 'verified'
  }];


  const [followStates, setFollowStates] = React.useState(
    featuredHosts?.reduce((acc, host) => ({
      ...acc,
      [host?.id]: host?.isFollowing
    }), {})
  );

  const handleFollow = (hostId) => {
    setFollowStates((prev) => ({
      ...prev,
      [hostId]: !prev?.[hostId]
    }));
    onFollow(hostId, !followStates?.[hostId]);
  };

  const getBadgeIcon = (badge) => {
    switch (badge) {
      case 'verified':
        return { name: 'BadgeCheck', color: 'var(--color-primary)' };
      case 'featured':
        return { name: 'Star', color: 'var(--color-warning)' };
      default:
        return null;
    }
  };

  return (
    <div className="featured-voices-section bg-card border border-border rounded-lg p-6">
      <div className="section-header flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
            <Icon name="Mic2" size={20} color="var(--color-primary)" />
          </div>
          <div>
            <h2 className="text-lg font-heading font-semibold text-foreground">
              Избранные голоса
            </h2>
            <p className="text-sm text-muted-foreground">
              Рекомендуем послушать
            </p>
          </div>
        </div>
      </div>
      <div className="featured-grid grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {featuredHosts?.map((host) => {
          const badgeIcon = getBadgeIcon(host?.badge);
          return (
            <div
              key={host?.id}
              className="featured-card bg-muted/50 rounded-lg p-4 hover:bg-muted transition-colors duration-200">

              <div className="card-header flex items-start gap-3 mb-3">
                <div className="host-avatar relative w-12 h-12 rounded-full overflow-hidden bg-muted flex-shrink-0">
                  <Image
                    src={host?.avatar}
                    alt={host?.avatarAlt}
                    className="w-full h-full object-cover" />

                  {badgeIcon &&
                  <div className="badge-icon absolute -bottom-1 -right-1 w-5 h-5 rounded-full bg-card flex items-center justify-center">
                      <Icon name={badgeIcon?.name} size={14} color={badgeIcon?.color} />
                    </div>
                  }
                </div>

                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-heading font-semibold text-foreground truncate">
                    {host?.name}
                  </h3>
                  <div className="flex items-center gap-3 text-xs text-muted-foreground mt-1">
                    <span>{(host?.followers / 1000)?.toFixed(1)}K подписчиков</span>
                    <span>•</span>
                    <span>{host?.broadcasts} эфиров</span>
                  </div>
                </div>
              </div>
              <p className="text-sm text-muted-foreground line-clamp-2 mb-4">
                {host?.bio}
              </p>
              <Button
                variant={followStates?.[host?.id] ? "outline" : "default"}
                size="sm"
                fullWidth
                iconName={followStates?.[host?.id] ? "UserCheck" : "UserPlus"}
                iconPosition="left"
                onClick={() => handleFollow(host?.id)}>

                {followStates?.[host?.id] ? 'Подписан' : 'Подписаться'}
              </Button>
            </div>);

        })}
      </div>
    </div>);

};

export default FeaturedVoices;